export default __webpack_public_path__ + "static/media/hamburger-btn.b6560530.svg";